import React, { Component,Fragment } from 'react';
import { putToast, getObjects, loadObject, adminloadTP, deleteObject, updateObject, tournamentAddRound, tournamentUpdateRound, tournamentRemoveRound, AuthenticatedUser, stopTimer } from "../../../api";
import TournamentPageTemplate from '../tournamentPageTemplate'
import RoundTemplateCube from '../cubes/config/roundAvailabilityCube';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import DateTimePicker from 'react-datetime-picker';
import TagList from "../../../common/tagList"
import {Link} from 'react-router-dom';

const _ = require("lodash");

class TournamentConfigRounds extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.onTemplateChange = this.onTemplateChange.bind(this);
        this.onAddToTournament = this.onAddToTournament.bind(this);
        this.onRemoveRound = this.onRemoveRound.bind(this);
        this.onEventChanged = this.onEventChanged.bind(this);
        this.onRoundDetails = this.onRoundDetails.bind(this);

        this.state = {
            loading: true,
            user: user,
            tData: {},
            pid: params.pid,
            selectedRound: null,
            selectedTemplate: ""                        
        }

    }

    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            adminloadTP('none', 'zulu', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    getObjects('tRound').then(d3 => {
                        if (d3 && d3.error) {
                            console.log(d3.error);
                        } else {
                            this.setState({ pid: pid, tData: d2.tournamentPage, tUsers: d2.tUsers, tRounds: d3, loading: false});                    
                        }
                    });                    
                }
            });
        } else this.setState({ loading: false});
    };

    onTemplateDetails(selectedId) {
        loadObject('tRound', selectedId).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({ selectedRound: d2, selectedTemplate: d2.template,
                    startDate: new Date(),
                    stopDate: new Date(),
                    dueDate: new Date(),
                    postedDate: new Date()
                });
                this.form && this.form.reset()                   
            }
        });
    }

    onRoundDetails(round) {       
        this.setState({ selectedRound: round, selectedTemplate: round.template,
            startDate: new Date(round.startDate ? round.startDate : null),
            stopDate: new Date(round.stopDate ? round.stopDate : null),
            dueDate: new Date(round.dueDate ? round.dueDate : null),
            postedDate: new Date(round.postedDate ? round.postedDate : null),
        });
    }

    onStartDateChange = startDate => this.setState({ startDate })    
    onStopDateChange = stopDate => this.setState({ stopDate })    
    onDueDateChange = dueDate => this.setState({ dueDate })
    
    onValidSubmit = (event, values) => {
        const {selectedRound, selectedTemplate} = this.state;
        if (!selectedRound || !selectedTemplate) return;
        const id = (selectedTemplate === selectedRound.template) ? selectedRound._id : null;
        const formData = new FormData(document.getElementById('mainForm'));
        formData.append("startDate", this.state.startDate)
        formData.append("stopDate", this.state.stopDate)        
        formData.append("dueDate", this.state.dueDate)
        formData.append("status", 'new')

        if (selectedRound.isCopy) {
            tournamentUpdateRound(formData, this.state.selectedRound._id, this.state.tData._id).then(d2 => {
                if (d2.error) {
                    console.log(d2.error);
                    putToast.error(d2 ? d2.error : "Error - no data");
                } else {
                    putToast.success(d2.message);    
                    _.extend(selectedRound, values);
                    this.setState({ tData: d2.tournamentPage, selectedRound: selectedRound, selectedTemplated: selectedRound.template });  
                }
            });                     
        } else {
            updateObject('tRound', formData, id).then(d2 => {
                if (d2.error) {
                    console.log(d2.error);
                    putToast.error(d2 ? d2.error : "Error - no data");
                } else {
                    getObjects('tRound').then(d3 => {
                        if (d3 && d3.error) {
                            console.log(d3.error);
                        } else {
                            putToast.success(d2.message);    
                            this.setState({ selectedRound: d2.tRound, selectedTemplated: d2.tRound.template, tRounds: d3  });   
                        }
                    });
                }
            });  
        }
    };
    

    onInvalidSubmit = (round, errors, values) => {
        //this.setState({errors, values});
    };
    
    onTemplateChange(ev) {
        this.setState({ selectedTemplate:  ev.target.value});   
    }

    onAddToTournament(ev) {
        ev.preventDefault();
        const formData = new FormData(document.getElementById('mainForm'));
        formData.append("startDate", this.state.startDate)
        formData.append("stopDate", this.state.stopDate)        
        formData.append("dueDate", this.state.dueDate)
        formData.append("status", 'new')

        tournamentAddRound(formData, this.state.tData._id).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({ tData:  d2.tournamentPage});   
            }
        });
    }

    onRemoveRound(ev) {
        ev.preventDefault();

        if (this.state.selectedRound.isCopy) {
            tournamentRemoveRound(this.state.selectedRound._id, this.state.tData._id).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ tData:  d2.tournamentPage});   
                }
            });
        } else {
            deleteObject('tRound', this.state.selectedRound._id).then(d2 => {
                if (d2.error) {
                    console.log(d2.error);
                } else {
                    getObjects('tRound').then(d3 => {
                        if (d3 && d3.error) {
                            console.log(d3.error);
                        } else {
                            putToast.success(d2.message);    
                            this.setState({ selectedRound: null, selectedTemplated: "", tRounds: d3  });   
                        }
                    });                
                }
            });
        }
    }

    onEventChanged(ev) {
        //ev.preventDefault();

        const selectedEventId = ev.target.value;
        this.setState({
            selectedEvent: this.state.tData.events.find(x=>x._id === selectedEventId),
            selectedRoundEvent: this.state.selectedRound.events.find(x=>x.eventId === selectedEventId),
        });
        /*        
        const {selectedRound} = this.state;
        if(!selectedRound || !selectedEventId) return;

        const roundEvent = selectedRound.events.find(x=>x._id === selectedEventId);

        if(roundEvent) {
            roundEvent.maxRoomCount = sele
        }
        */
    }

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if (this.state.selectedRound && this.state.selectedRound.isCopy) this.form && this.form.reset()                   
    }

    render(){
        if (this.state.loading) { return null; }

        stopTimer();      
        const { tData, tRounds, user, selectedRound, selectedTemplate } = this.state;
        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Configuration - ${user.displayname}`} title3=""
            bcTitle="Configure Rounds" bcParents={[{name: tData.title, url: `/tournament/config/${tData._id}`}]} 
        >                     
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-6">

                        <div className="card" style={{marginBottom: "10px"}}>
                            <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                <h4>Rounds</h4>
                            </div>   

                            <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                {tData.rounds.map((round, index) => 
                                    <div className="row" key={index}>
                                        <div key={index} className="col-12">
                                            <span key={index} onClick={() => this.onRoundDetails(round)} style={{cursor: 'pointer'}}>
                                                <RoundTemplateCube key={index} tournament={tData} round={round} user={user}  />
                                            </span>
                                        </div>
                                    </div>
                                )} 
                            </div>

                            <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                &nbsp;
                            </div>
                        </div> 


                    </div>
                    <div className="col-sm-6">                         

                        <div className="card" style={{marginBottom: "10px"}}>
                            <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                <h4>Round Library</h4>
                            </div>   

                            <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                {tRounds.map((round, index) => 
                                    <button style={{margin: "4px"}} type="button" className="btn btn-warning" onClick={()=>this.onTemplateDetails(round._id)}>{round.template}</button>
                                )}                                                                         
                            </div>

                            <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                &nbsp;                                
                            </div>
                        </div> 

                        <AvForm id="mainForm" className="needs-validation" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} model={selectedRound} ref={c => (this.form = c)}>
                            <div className="card" style={{marginBottom: "10px"}}>
                                <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                    <h4>Round Details
                                    {selectedRound &&                            
                                    <>
                                    {selectedRound.template === selectedTemplate
                                    ?    <button  className="btn btn-primary pull-right" type="submit" >Save</button>
                                    :    <button  className="btn btn-primary pull-right" type="submit" >Save As</button>
                                    }
                                    <button style={{marginRight: "8px"}} ttype="button" className="btn btn-primary pull-right" onClick={this.onAddToTournament}>Add  </button>
                                    {true && <button style={{marginRight: "8px"}} ttype="button" className="btn btn-primary pull-right" onClick={this.onRemoveRound}>Remove  </button> }
                                    </>
                                    }
                                    </h4>     
                                </div>   
                                <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                    {selectedRound                         
                                    ?   <Fragment>
                                            {selectedRound.isCopy 
                                            ?   <AvField disabled label="Template" grid={{xs: 10}} name="template" id="template" type="text" onChange={this.onTemplateChange}/>                                             
                                            :   <AvField label="Template" grid={{xs: 10}} name="template" id="template" type="text" onChange={this.onTemplateChange}/>
                                            }
                                            <AvField label="Title" grid={{xs: 10}} name="title" id="title" type="text" />
                                            <AvField label="Abbr" grid={{xs: 10}} name="abbr" id="abbr" type="text" />
                                            <AvField disabled label="Status" grid={{xs: 10}} name="status" id="status" type="text" />
                                            <AvField label="Round Order" grid={{xs: 10}} name="roundIndex" id="roundIndex" type="text"/>
                                            <hr />
                                            <AvField disabled label="Mode" grid={{xs: 10}} name="mode" id="mode" type="text" />
                                            <AvField label="Category" grid={{xs: 10}} name="category" id="category" type="select">                                 
                                                <option disabled value="">Select Category</option>                                 
                                                <option value="debate" key="debate">Debate</option>                                 
                                                <option value="interp" key="interp">Interp</option>                                                                                                                    
                                                <option value="platform" key="platform">Platform</option>                                                                                                                    
                                                <option value="limited-prep" key="limited-prep">Limited Prep</option>                                                                                                                    
                                            </AvField>                                            
                                            <AvField label="Resolution" grid={{xs: 10}} name="resolution" id="resolution" type="text" />                                             <hr />
                                            {selectedRound.isCopy && <>

                                            <div className="row">
                                                <div className="col-sm-2">
                                                    Start Date
                                                </div>
                                                <div className="col-sm-10">  
                                                    <DateTimePicker
                                                        onChange={this.onStartDateChange}
                                                        value={this.state.startDate}
                                                        disableClock
                                                    />
                                                </div>
                                            </div>
                                            <br />
                                            <div className="row">
                                                <div className="col-sm-2">
                                                    End Date
                                                </div>
                                                <div className="col-sm-10">  
                                                    <DateTimePicker
                                                        onChange={this.onStopDateChange}
                                                        value={this.state.stopDate}
                                                        disableClock
                                                    />
                                                </div>
                                            </div>
                                            <br />                                               
                                            <div className="row">
                                                <div className="col-sm-2">
                                                    Due Date
                                                </div>
                                                <div className="col-sm-10">  
                                                    <DateTimePicker
                                                        onChange={this.onDueDateChange}
                                                        value={this.state.dueDate}
                                                        disableClock
                                                    />
                                                </div>
                                            </div>
                                            <br />
                                            <div className="row">
                                                <div className="col-sm-2">
                                                    Posted Date
                                                </div>
                                                <div className="col-sm-10">  
                                                    <DateTimePicker
                                                        value={this.state.postedDate}
                                                        disableClock
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <hr />
                                            <h4>Round Events
                                                <Link to={`${process.env.PUBLIC_URL}/tournament/config/roundEvents/${tData._id}/${selectedRound._id}`} style={{marginRight: "8px"}} type="button" className="btn btn-primary pull-right" >Edit Round Events</Link>
                                            </h4>                                            
                                            <TagList title="" tags={selectedRound.events.map(x=>{
                                                return (
                                                    tData.events.find(y=>y._id === x.eventId).abbr
                                                )
                                                })
                                            } hideBorder/>                                            
                                            <hr />
                                            </> }                                                                                       
                                            
                                        </Fragment>  


                                    :   <p style={{backgroundColor: "#b48c50", color: "white", padding: "10px", marginTop: "25px", marginBottom: "50px"}}>No Round Selected</p>
                                    }
                                </div>
                                <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                    &nbsp;

                                </div>
                            </div> 
                        </AvForm>
                    </div>
                </div>  
            </div>
            </TournamentPageTemplate>
            
        )
    }
}

export default TournamentConfigRounds;